import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

const Svg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M916.29 75.71a40 40 0 0 0-56.57 0l-53.4 53.4-78.9 78.89-187.74 187.75a40 40 0 0 0 0 56.56 40 40 0 0 0 56.57 0L784 264.57l78.89-78.9 53.4-53.39a40 40 0 0 0 0-56.57z"
      fill="currentColor"
    />
    <path
      d="M824 367.46a40 40 0 0 0-40 39.23V840a40 40 0 0 1-40 40H216a40 40 0 0 1-40-40V248a40 40 0 0 1 40-40h371a40 40 0 0 0 0-80H166a70 70 0 0 0-70 70v692a70 70 0 0 0 70 70h628a70 70 0 0 0 70-70V405.09a40 40 0 0 0-40-37.63z"
      fill="currentColor"
    />
    <path
      d="M224 600a40 40 0 0 0 40 40h368a40 40 0 0 0 0-80H264a40 40 0 0 0-40 40zM440 384H264a40 40 0 0 0 0 80h176a40 40 0 0 0 0-80z"
      fill="currentColor"
    />
  </svg>
)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent